module.exports = __webpack_public_path__ + "74c652671225d6ded874a648502e5f0a.ttf";